import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import TheatreSidebar from "../Layouts/TheatreSidebar";

export class IntraOperativeSwabInstruments extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      AbdominalGauzeFirstCount: "",
      AbdominalGauzeWoundClosure: "",
      AbdominalGauzeFinalCount: "",
      SmallGauzesFirstCount: "",
      SmallGauzesWoundClosure: "",
      SmallGauzesFinalCount: "",
      TonsilswabsFirstCount: "",
      TonsilswabsWoundClosure: "",
      TonsilswabsFinalCount: "",
      CottonoidsFirstCount: "",
      CottonoidsWoundClosure: "",
      CottonoidsFinalCount: "",
      ThroatpackFirstCount: "",
      ThroatpackWoundClosure: "",
      ThroatpackFinalCount: "",
      TapesFirstCount: "",
      TapesWoundClosure: "",
      TapesFinalCount: "",
      BladesFirstCount: "",
      BladesWoundClosure: "",
      BladesFinalCount: "",
      NeedlesFirstCount: "",
      NeedlesWoundClosure: "",
      NeedlesFinalCount: "",
      CountsCorrect: "",
      IfNotAction: "",
      InstrumentsUsed: "",
      ScrubNursesname: "",
      CirculatingNursesName: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
  }

  proceedEvent(event) {
    window.location.href = "/theatre/post/op/observations/care2";
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };

    console.log(headers);

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var dict = {
        AbdominalGauzeFirstCount:
          this.state.tablevaluesglobal[i]["AbdominalGauzeFirstCount"],
        AbdominalGauzeWoundClosure:
          this.state.tablevaluesglobal[i]["AbdominalGauzeWoundClosure"],
        AbdominalGauzeFinalCount:
          this.state.tablevaluesglobal[i]["AbdominalGauzeFinalCount"],
        SmallGauzesFirstCount:
          this.state.tablevaluesglobal[i]["SmallGauzesWoundClosure"],
        SmallGauzesWoundClosure:
          this.state.tablevaluesglobal[i]["SmallGauzesWoundClosure"],
        SmallGauzesFinalCount:
          this.state.tablevaluesglobal[i]["SmallGauzesFinalCount"],
        TonsilswabsFirstCount:
          this.state.tablevaluesglobal[i]["TonsilswabsFirstCount"],
        TonsilswabsWoundClosure:
          this.state.tablevaluesglobal[i]["TonsilswabsFinalCount"],
        TonsilswabsFinalCount:
          this.state.tablevaluesglobal[i]["TonsilswabsFinalCount"],
        CottonoidsFirstCount:
          this.state.tablevaluesglobal[i]["CottonoidsFirstCount"],
        CottonoidsWoundClosure:
          this.state.tablevaluesglobal[i]["CottonoidsWoundClosure"],
        CottonoidsFinalCount:
          this.state.tablevaluesglobal[i]["CottonoidsFinalCount"],
        ThroatpackFirstCount:
          this.state.tablevaluesglobal[i]["ThroatpackFirstCount"],
        ThroatpackWoundClosure:
          this.state.tablevaluesglobal[i]["ThroatpackWoundClosure"],
        ThroatpackFinalCount:
          this.state.tablevaluesglobal[i]["ThroatpackFinalCount"],
        TapesFirstCount: this.state.tablevaluesglobal[i]["TapesFirstCount"],
        TapesWoundClosure: this.state.tablevaluesglobal[i]["TapesWoundClosure"],
        TapesFinalCount: this.state.tablevaluesglobal[i]["TapesFinalCount"],
        BladesFirstCount: this.state.tablevaluesglobal[i]["BladesFirstCount"],
        BladesWoundClosure:
          this.state.tablevaluesglobal[i]["BladesWoundClosure"],
        BladesFinalCount: this.state.tablevaluesglobal[i]["BladesFinalCount"],
        NeedlesFirstCount: this.state.tablevaluesglobal[i]["NeedlesFirstCount"],
        NeedlesWoundClosure:
          this.state.tablevaluesglobal[i]["NeedlesWoundClosure"],
        NeedlesFinalCount: this.state.tablevaluesglobal[i]["NeedlesFinalCount"],
        CountsCorrect: this.state.tablevaluesglobal[i]["CountsCorrect"],
        IfNotAction: this.state.tablevaluesglobal[i]["IfNotAction"],
        InstrumentsUsed: this.state.tablevaluesglobal[i]["InstrumentsUsed"],
        ScrubNursesname: this.state.tablevaluesglobal[i]["ScrubNursesname"],
        CirculatingNursesName:
          this.state.tablevaluesglobal[i]["CirculatingNursesName"],
      };

      axios
        .post(
          this.api_url+"optheatre/operativeorders/intra/optheatre/swabinstruments",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history
          if (response.data) {
            console.log(headers);
            axios
              .post(
                this.api_url+"/optheatre/operativeorders/intra/optheatre/swabinstruments",
                { headers: headers }
              )
              .then((response) => {
                console.log(response);
                let table = response.data;
                console.log(table);
                let object = {};
                for (let i = 0; i < table.length; i++) {
                  delete table[i]._id;
                  delete table[i].timeOfRegistration;
                  table[i].clickEvent = () => this.handleRowClick(table[i]);
                }
                // table = JSON.stringify(table);
                this.TableData = table;
                console.log(this.TableData);
                this.setState({
                  DataLoaded: true,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            if (response.data["status"]) {
              $(".alert-success").show();
              setTimeout(function () {
                // alert('sdsd')
                $(".HistoryModal").show();
              }, 1500);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};

    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.AbdominalGauzeFirstCount = data[i][0];
      trimobj.AbdominalGauzeWoundClosure = data[i][1];
      trimobj.AbdominalGauzeFinalCount = data[i][2];
      trimobj.SmallGauzesFirstCount = data[i][3];
      trimobj.SmallGauzesWoundClosure = data[i][4];
      trimobj.SmallGauzesFinalCount = data[i][5];
      trimobj.TonsilswabsFirstCount = data[i][6];
      trimobj.TonsilswabsWoundClosure = data[i][7];
      trimobj.TonsilswabsFinalCount = data[i][8];
      trimobj.CottonoidsFirstCount = data[i][9];
      trimobj.CottonoidsWoundClosure = data[i][10];
      trimobj.CottonoidsFinalCount = data[i][11];
      trimobj.ThroatpackFirstCount = data[i][12];
      trimobj.ThroatpackWoundClosure = data[i][13];
      trimobj.ThroatpackFinalCount = data[i][14];
      trimobj.TapesFirstCount = data[i][15];
      trimobj.TapesWoundClosure = data[i][16];
      trimobj.TapesFinalCount = data[i][17];
      trimobj.BladesFirstCount = data[i][18];
      trimobj.BladesWoundClosure = data[i][19];
      trimobj.BladesFinalCount = data[i][20];
      trimobj.NeedlesFirstCount = data[i][21];
      trimobj.NeedlesWoundClosure = data[i][22];
      trimobj.NeedlesFinalCount = data[i][23];
      trimobj.CountsCorrect = data[i][24];
      trimobj.IfNotAction = data[i][25];
      trimobj.InstrumentsUsed = data[i][26];
      trimobj.ScrubNursesname = data[i][27];
      trimobj.CirculatingNursesName = data[i][28];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      [
        "First Count",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      [
        "Wound Closure Count",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      [
        "Final Count",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      // ["4th", "", ""],
    ];

    const columns = [
      "AbdominalGauzeFirstCount",
      "AbdominalGauzeWoundClosure",
      "AbdominalGauzeFinalCount",
      "SmallGauzesFirstCount",
      "SmallGauzesWoundClosure",
      "SmallGauzesFinalCount",
      "TonsilswabsFirstCount",
      "TonsilswabsWoundClosure",
      "TonsilswabsFinalCount",
      "CottonoidsFirstCount",
      "CottonoidsWoundClosure",
      "CottonoidsFinalCount",
      "ThroatpackFirstCount",
      "ThroatpackWoundClosure",
      "ThroatpackFinalCount",
      "TapesFirstCount",
      "TapesWoundClosure",
      "TapesFinalCount",
      "BladesFirstCount",
      "BladesWoundClosure",
      "BladesFinalCount",
      "NeedlesFirstCount",
      "NeedlesWoundClosure",
      "NeedlesFinalCount",
      "CountsCorrect",
      "IfNotAction",
      "InstrumentsUsed",
      "ScrubNursesname",
      "CirculatingNursesName",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    // {""":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      AnteNatalHistoryTableTrimester,
      AnteNatalHistoryTableDate,
      PreviousFacilityVisitDate,
      AnteNatalHistoryTableResult,
      patientName,
    } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "ObservationsCare1Time",
          field: "ObservationsCare1Time",
          sort: "asc",
          width: 50,
        },
        {
          label: "Airway",
          field: "Airway",
          sort: "asc",
          width: 50,
        },
        {
          label: "oxygen",
          field: "oxygen",
          sort: "asc",
          width: 50,
        },
        {
          label: "Resp",
          field: "Resp",
          sort: "asc",
          width: 50,
        },
        {
          label: "Pulse",
          field: "Pulse",
          sort: "asc",
          width: 50,
        },
        {
          label: "Temp",
          field: "Temp",
          sort: "asc",
          width: 50,
        },
        {
          label: "BP",
          field: "BP",
          sort: "asc",
          width: 50,
        },
        {
          label: "SPO2",
          field: "SPO2",
          sort: "asc",
          width: 50,
        },
        {
          label: "LOC",
          field: "LOC",
          sort: "asc",
          width: 50,
        },
        {
          label: "Headlift",
          field: "Headlift",
          sort: "asc",
          width: 50,
        },
        {
          label: "LimbObs",
          field: "LimbObs",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />
        <TheatreSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Intra-Operative Swab Instruments
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* <div className="alert alert-danger contactAdmin" style={displayHidden} role="alert">
                            <strong>Wait! </strong>Contact Administrator to get account approval.
                        </div> */}
            </form>
            <div className="modal  HistoryModal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {" "}
                      {patientName}`s IntraOperative Swab Instruments Modal
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* <div className="py-1">
                        <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                    </div> */}
                    <br />
                    <br />
                    <br />

                    <a
                      className="btn btn-danger proceed"
                      onClick={this.proceedEvent}
                      style={width100}
                    >
                      Proceed to Next
                    </a>
                    <Preview id={"jsx-template"}>
                      <b>NAME: </b>
                      {patientName}

                      <MDBDataTable striped bordered data={tabledata} />
                    </Preview>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default IntraOperativeSwabInstruments;
